import Address from '/src/build/backend/js/plugin/address.js';

export default class Billing extends Address {

    modalText = {
        add: {
            title: 'Nuovi dati di fatturazione',
        },
        modify: {
            title: 'Modifica dati di fatturazione',
        },
        delete: {
            title: 'Elimina dati di fatturazione',
            description: 'Vuoi eliminare i seguenti dati di fatturazione:'
        }
    }

    constructor (container, prefix = 'billing_', required = false) {

        super(container, prefix, required);

        if (this.container.querySelector('input[name="'+this.prefix+'type"]')) {
            this.type = this.container.querySelector('input[name="'+this.prefix+'type"]');
        } else {
            this.type = this.container.querySelector('select[name="'+this.prefix+'type"]');
        }

        this.businessName = this.container.querySelector('input[name="'+this.prefix+'business_name"]');
        this.cf = this.container.querySelector('input[name="'+this.prefix+'cf"]');
        this.pi = this.container.querySelector('input[name="'+this.prefix+'pi"]');
        this.sdi = this.container.querySelector('input[name="'+this.prefix+'sdi"]');
        this.pec = this.container.querySelector('input[name="'+this.prefix+'pec"]');

    }

    initForm() {

        super.initForm();

        this.type.disabled = false;
        this.cf.disabled = false;

        setRequired(this.type, true);
    
        if (this.type.value == 'business') {
    
            this.businessName.parentElement.parentElement.classList.remove('d-none');
            this.businessName.disabled = false;
            console.log(this.businessName);
    
            this.pi.parentElement.parentElement.classList.remove('d-none');
            this.pi.disabled = false;

            this.sdi.parentElement.parentElement.classList.remove('d-none');
            this.sdi.disabled = false;
    
            this.pec.parentElement.parentElement.classList.remove('d-none');
            this.pec.disabled = false;
    
            this.name.parentElement.parentElement.classList.add('d-none');
            this.name.disabled = true;
    
            this.surname.parentElement.parentElement.classList.add('d-none');
            this.surname.disabled = true;

            if (this.required) { 

                setRequired(this.businessName, true);
                setRequired(this.pi, true);
                setRequired(this.cf, false);
                setRequired(this.name, false);
                setRequired(this.surname, false);
            
            }
    
        } else if (this.type.value == 'private') {
    
            this.name.parentElement.parentElement.classList.remove('d-none');
            this.name.disabled = false;
    
            this.surname.parentElement.parentElement.classList.remove('d-none');
            this.surname.disabled = false;
    
            this.businessName.parentElement.parentElement.classList.add('d-none');
            this.businessName.disabled = true;
    
            this.pi.parentElement.parentElement.classList.add('d-none');
            this.pi.disabled = true;
    
            this.sdi.parentElement.parentElement.classList.add('d-none');
            this.sdi.disabled = true;
    
            this.pec.parentElement.parentElement.classList.add('d-none');
            this.pec.disabled = true;
    
            if (this.required) { 

                setRequired(this.name, true);
                setRequired(this.surname, true);
                setRequired(this.cf, true);
                setRequired(this.businessName, false);
                setRequired(this.pi, false);
            
            }
    
        }

        check();
        
    }

    setForm(data) {
    
        this.type.value = data.type;
        this.businessName.value = data.businessName;
        this.cf.value = data.cf;
        this.pi.value = data.pi;
        this.sdi.value = data.sdi;
        this.pec.value = data.pec;

        super.setForm(data);

    }

    resetForm() {

        this.container.querySelectorAll('input, select').forEach(element => {
            
            var prefix = element.name.substring(0, this.prefix.length);

            if (prefix == this.prefix) {

                if (element.name == this.prefix+'type') {
                    element.value = 'private';
                } else if (element.name == this.prefix+'country') {
                    $(element).val('IT').trigger('change');
                } else if (element.name == this.prefix+'phone_prefix') {
                    $(element).val('+39').trigger('change');
                } else {
                    element.value = '';
                }

                setRequired(element, false);

            }

        });

        check();

    }

}